document.addEventListener('DOMContentLoaded', function () {
    let triggers = document.querySelectorAll('.header__mob-categories-list li span');
    triggers = Array.from(triggers).filter((t) => t.nextElementSibling?.tagName === 'UL');

    const subMenuList = document.querySelectorAll('.header__mob-categories-list .header__mob-subcategory-list');

    triggers.forEach((item, i) => {
        item.addEventListener('click', () => {
            subMenuList[i].classList.toggle('hidden-lg');
            item.querySelector('img').classList.toggle('rotate-180');
        })
    })
});